// The passes a new project starts with. Keep the literal in this dependency-free guidance module so
// both application code and standalone guidance bundles import the same value.
//
// Existing projects are deliberately not backfilled when this changes: enabling a pass retroactively
// would start filing that pass's bugs across projects already in flight. The order is also persisted in
// projects.enabled_polish_passes, so retain the historical order when adding a pass.
export const DEFAULT_ENABLED_PASSES = [
  'network-performance',
  'react-rendering',
  'layout-shift',
  'glitches',
  'user-experience',
  'accessibility',
  'seo',
  'ui-details',
] as const
